
export const GET_INFO_CUSTOMER = 'GET_INFO_CUSTOMER';
export const GET_INFO_CUSTOMER_DONE = 'GET_INFO_CUSTOMER_DONE';
export const REQUEST_OTP_PHONE_EXIST = 'REQUEST_OTP_PHONE_EXIST';
export const REQUEST_OTP_NEW_PHONE = 'REQUEST_OTP_NEW_PHONE';
export const VERIFY_OTP_PHONE = 'VERIFY_OTP_PHONE';
export const UPDATE_INFO_CUSTOMER = 'UPDATE_INFO_CUSTOMER';